import { ToggleSwitchField, ToggledStatus } from "@kaizen/draft-form"
import { useFlags } from "@cultureamp/ca-launchdarkly-react"
import React, { useState } from "react"

export type ContentProps = {
  className?: string
  legacyContent?: React.ReactNode
}

export const Content: React.FC<ContentProps> = ({
  className,
  legacyContent,
}) => {
  const { employeeProfileTimelineEnable } = useFlags()
  const [legacyMode, setLegacyMode] = useState(false)

  return (
    <div className={className}>
      {employeeProfileTimelineEnable && (
        <ToggleSwitchField
          labelText="Legacy mode"
          onToggle={() => setLegacyMode(!legacyMode)}
          toggledStatus={legacyMode ? ToggledStatus.ON : ToggledStatus.OFF}
        />
      )}
      {legacyMode || !employeeProfileTimelineEnable ? (
        legacyContent
      ) : (
        <>Awesome new timeline view</>
      )}
    </div>
  )
}

export default Content
